/**
 * The in-app index of the current history entry, or `null` for an entry
 * react-router did not create. react-router stamps each entry it creates with
 * an `idx`; the first page of a visit (a deep link, a new tab, a reload) sits
 * at 0, and the browser gives no way to read the entry before it. Hooks read
 * the index through here rather than the browser's history state (bos-app#137).
 */
export const currentHistoryIndex = (): number | null => {
    if (typeof globalThis.window === 'undefined') {
        return null;
    }

    const historyState = globalThis.window.history.state as
        { idx?: number } | null | undefined;

    return typeof historyState?.idx === 'number' ? historyState.idx : null;
};

/**
 * Whether there is an in-app history entry behind the current one, so that
 * `navigate(-1)` stays inside the app.
 */
export const canNavigateBack = (): boolean => {
    const index = currentHistoryIndex();
    return index !== null && index > 0;
};
